import StitchFeaturePage from "../../components/sections/StitchFeaturePage";
import SectionLabel from "../../components/ui/SectionLabel";

const features = [
  { title: "Contact & Lead Management", desc: "Capture and organise prospects, clients, and communication history in one place." },
  { title: "Sales Pipeline", desc: "Pipeline stages, follow-up tasks, and proposal visibility tailored to your workflow." },
  { title: "Reports Dashboard", desc: "Dashboards, activity logs, and role-based access for leadership and operators." },
  { title: "Industry Modules", desc: "Extend the CRM around legal, real estate, healthcare, education, and e-commerce workflows." },
];

const CrmDevelopment = () => (
  <StitchFeaturePage
    label="SERVICE · CUSTOM CRM"
    title="A CRM built"
    titleAccent="for your workflow."
    subtitle="Not Zoho. Not Salesforce. A system built exactly around how your team sells, follows up, and closes."
    features={features}
    ctaLabel="BUILD YOUR CRM"
  >
    <div style={{ display: "grid", gap: 28 }}>
      <div style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 24, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
        Most businesses pay for 80% of features they never use. Pre-built CRMs force your team to work around the software. We build around the way your team already works.
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20 }}>
        {[
          "Law Firm: Client intake, case tracking, billing, court dates, document management",
          "Real Estate: Property listings, buyer journey, site visit scheduler, commission tracker",
          "Healthcare: Patient lifecycle, multi-branch database, referral tracking",
          "Education: Student leads, admissions pipeline, fee management",
          "E-Commerce: Customer LTV, repeat purchase triggers, churn prediction",
        ].map((item) => (
          <div key={item} style={{ background: "#0E0E0E", border: "1px solid rgba(212,168,67,0.18)", borderRadius: 4, padding: 22, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.75 }}>
            {item}
          </div>
        ))}
      </div>

      <div style={{ background: "#1A1208", border: "1px solid rgba(212,168,67,0.22)", borderRadius: 4, padding: 24, fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "#F8F4EC", lineHeight: 1.8 }}>
        All CRM builds include full source code ownership · 3 months support · Staff training · Documentation
      </div>
    </div>
  </StitchFeaturePage>
);

export default CrmDevelopment;
